module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvYXNzZXRzL2JiYzBkZDc5NzE3YmZhMzM4YTE5OWJiMjZjZGQ3ODBiLnR0ZiI7"